import { Component, HostBinding, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { UserService } from '../../../shared/services/user.service';
import { ScrollerDirective } from '../../../shared/directives/scroller.directive';
import { AfterViewInitDirective } from '../../../shared/directives/after-view-init.directive';

import { LastCallOffWidgetComponent } from './last-call-off-demand-widget.component';

@Component({
	selector: 'copo-ecall-off-follow-up',
	templateUrl: './ecall-off-follow-up.component.html',
	imports: [AfterViewInitDirective, ScrollerDirective, TranslateModule, LastCallOffWidgetComponent]
})
export class ECallOffFollowUpComponent implements OnInit {
	@HostBinding('class.passthrough') readonly passthrough = true;
	canCallByVolume = false;

	constructor(private readonly userService: UserService) {}

	ngOnInit(): void {
		this.canCallByVolume = this.userService.user.hasServiceParameterEqualsTo('PCALL', 'ByVolume', 'True');
	}
}
